import request from '@/utils/request'

// 获取NOI大纲列表
export function getOutlineList(params) {
  return request({
    url: '/api/outline/list',
    method: 'get',
    params
  })
}

// 获取NOI大纲统计数据
export function getOutlineStatistics() {
  return request({
    url: '/api/outline/statistics',
    method: 'get'
  })
}

// 获取大纲详细统计数据
export function getOutlineDetailStatistics() {
  return request({
    url: '/api/outline/statistics/detail',
    method: 'get'
  })
}

// 更新NOI大纲掌握程度
export function updateOutlineStatus(id, status) {
  return request({
    url: `/api/outline/${id}/status`,
    method: 'put',
    data: {
      status: status
    }
  })
}

// 获取大纲掌握程度选项
export function getOutlineStatusOptions() {
  return request({
    url: '/api/outline/status-options',
    method: 'get'
  })
}

// 获取大纲级别选项
export function getOutlineLevelOptions() {
  return request({
    url: '/api/outline/level-options',
    method: 'get'
  })
}

// 获取所有大纲数据（用于选项）
export function getAllOutlineOptions() {
  return request({
    url: '/api/outline/all-options',
    method: 'get'
  })
}

// 获取所有一级大纲选项
export function getOutlineL1Options() {
  return request({
    url: '/api/outline/outline-l1-options',
    method: 'get'
  })
}

// 获取所有二级大纲选项
export function getOutlineL2Options() {
  return request({
    url: '/api/outline/outline-l2-options',
    method: 'get'
  })
}

// 获取所有三级大纲选项
export function getOutlineL3Options() {
  return request({
    url: '/api/outline/outline-l3-options',
    method: 'get'
  })
} 